<template>
  <div class="new-seg-main">
    <div class="new-seg-list">
      <div class="seg-item" v-for="(iti, itIndex) in innerItineraries" :key="itIndex">
        <div class="seg-change-info">
          <table class="seg-info-table">
            <tr>
              <td class="seg-logo-col">
                <div :class="['airline-logo', 'logo', `logo-${iti.orgDsts[0].airlineCode.toLocaleLowerCase()}`]"></div>
              </td>
              <td  class="seg-date-col">
                <div class="seg-time">{{ moment(iti.orgDsts[0].departureDate + ' ' + iti.orgDsts[0].departureTime).format('HH:mm') }}</div>
                <div class="seg-airport">{{ iti.orgDsts[0].departureAirPortName }} {{ iti.orgDsts[0].departureTerminal || '' }}</div>
              </td>
              <td class="seg-flight-type">
                <div class="seg-stop" v-if="iti.orgDsts[0].stopQuantity">经停: {{ iti.orgDsts[0].stopCitys | stopCity }}</div>
                <div class="seg-dur">
                  <span class="dur-time">  </span>
                </div>
                <div class="seg-airplane" v-if="iti.orgDsts[0].aircraftCode">机型: {{ iti.orgDsts[0].aircraftCode }}</div>
              </td>
              <td class="seg-date-col">
                <div class="seg-time">{{ moment(iti.orgDsts[0].arrivalDate + ' ' + iti.orgDsts[0].arrivalTime).format('HH:mm') }}</div>
                <div class="seg-airport">{{ iti.orgDsts[0].arrivalAirPortName  }} {{ iti.orgDsts[0].arrivalTerminal || ''  }}</div>
              </td>
              <td class="seg-day">航班日期：{{ iti.orgDsts[0].departureDate }}</td>
              <td class="seg-no">航班号：{{ iti.orgDsts[0].flightNo }}</td>
              <td class="seg-toggle">
                <div class="seg-toggle-btn" @click="toggleItiHandler(iti)">
                  <i class="l8-icon-outer">
                    <l8-icon class="l8-icon v-m" type="icon-xiajiantou"/>
                  </i>
                  <span class="seg-href v-m">展开预定</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <transition>
        <div class="seg-products" v-show="iti.checked">
          <div class="product-box">
            <table class="order-default-table product-table">
              <thead>
              <tr>
                <td>产品名称</td>
                <td>舱位</td>
                <td>权益优享</td>
                <td>票面价</td>
                <td>票价补差</td>
                <td>变更手续费</td>
                <td>燃油税补差</td>
                <td>机场建设费补差</td>
                <td>剩余座位</td>
                <td>选择</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(product, prodIndex) in iti.productPrices" :key="prodIndex">
                <td>{{ product.detail.services[0].productName }}</td>
                <td>{{ product.detail.services[0].cabinCode }}舱</td>
                <td>
                  <div style="padding-left: 15px; ">
                    <a-popover
                      trigger="hover"
                      overlayClassName="l8-order-popover order-primary-popover"
                      placement="bottom">
                      <template slot="content">
                        <div class="popover-benefit-table">
                          <table class="cell-body" style="width: 100%; margin-bottom: 10px">
                            <tr v-for="(item,index) in product.detail.services[0].benefit.benefits[0].luggageBenefitDetails" :key="index">
                              <td v-if="(index+1)%2===1" rowspan="2">{{passengerTypeLanguageMap[item.passengerType]}}</td>
                              <td v-if="(index+1)%2===1"><l8-icon type="icon-life-fi-trunk"></l8-icon> 托运行李</td>
                              <td v-if="(index+1)%2===0"><l8-icon type="icon-gongjuxiang"></l8-icon> 手提行李</td>
                              <td >{{item.name}}</td>
                            </tr>
                          </table>
                          <table>
                            <tr v-for="(benefit, bnfIndex) in product.benefits" :key="bnfIndex">
                              <td>
                                <l8-icon
                                  class="benefit-icon l8-icon v-m"
                                  :title="benefit.name"
                                  :type="benefit.icon || 'icon-zuanshi'"/>
                              </td>
                              <td>
                                <span>{{ benefit.name }}</span>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </template>
                      <template slot="title">
                        <span>服务权益</span>
                      </template>
                      <span v-if="product.benefits.length !== 0 || product.detail.services[0].benefit.benefits[0].luggageBenefitDetails.length !== 0">
                        <l8-icon class="benefit-icon l8-icon v-m" title="服务权益" type="icon-zuanshi"/>
                      </span>
                      <span v-else>无</span>
                    </a-popover>
                  </div>
                </td>
                <td>￥{{ product.detail.services[0].fareDetails[0].fares[0].amount }}</td>
                <td>￥{{ product.detail.services[0].changeServices[0].changeAmount }}</td>
                <td>￥{{ product.detail.services[0].changeServices[0].serviceAmount }}</td>
                <td>￥{{ product.detail.services[0].changeServices[0].fuelAmount }}</td>
                <td>￥{{ product.detail.services[0].changeServices[0].airportAmount }}</td>
                <td>{{ product.detail.services[0].changeServices[0].inventory ? inventory : '座位充足' }}</td>
                <td>
                  <a-radio :checked="product.detail.offerItemId === changeOfferItemId" :value="product.detail.offerItemId" @change="onProductChange($event, product.detail, iti.orgDsts[0])"></a-radio>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
import request from '@/assets/js/request'

import '@/components/l8-icon'

export default {
  props: {
    itineraries: {
      type: Array
    }
  },
  data () {
    return {
      innerItineraries: [],
      changeOfferItemId: '',
      passengerTypeLanguageMap: {
        'ADULT': '成人',
        'CHILD': '儿童',
        'INFANT': '婴儿'
      }
    }
  },
  created () {
    let temp = JSON.parse(JSON.stringify(this.itineraries))

    // 初始化航段产品参数
    _.each(temp, (iti) => {
      iti.checked = false
      iti.selectedProduct = ''

      _.each(iti.productPrices, (product) => {
        product.benefits = []
        // 格式化其他权益
        const services = product.detail.services
        services.forEach(item => {
          if (_.get(item, 'benefit.benefits[0]')) {
            item.benefit.benefits[0].luggageBenefitDetails = []
            item.benefit.benefits[0].languageBenefitDetails.forEach(element => {
              if (element.checkinBenefit) {
                element.checkinBenefit.passengerType = element.passengerType
                item.benefit.benefits[0].luggageBenefitDetails.push(element.checkinBenefit)
              }
              if (element.carryBenefit) {
                element.carryBenefit.passengerType = element.passengerType
                item.benefit.benefits[0].luggageBenefitDetails.push(element.carryBenefit)
              }
            })
          } else {
            item.benefit = {}
            item.benefit.benefits = []
            item.benefit.benefits[0] = {}
            item.benefit.benefits[0].luggageBenefitDetails = []
          }
        })
      })
    })

    this.innerItineraries = temp
    this.updateBenefit()
  },
  methods: {
    toggleItiHandler (iti) {
      this.$set(iti, 'checked', !iti.checked)
    },
    onProductChange (e, productDetail, orgdst) {
      this.changeOfferItemId = productDetail.offerItemId
      this.$emit('select', {
        product: productDetail,
        orgdst
      })
    },
    fetchBenefit () {
      let allSegProductsParams = []

      _.each(this.innerItineraries, (iti) => {
        const params = _.map(iti.productPrices, (product) => {
          return {
            arrCode: product.detail.services[0].arrivalCode,
            cabinCode: product.detail.services[0].cabinCode,
            refCabinCode: product.detail.services[0].refCabinCode,
            depCode: product.detail.services[0].departureCode,
            flightDate: this.moment(iti.orgDsts[0].departureDate).format('YYYY-MM-DD'),
            flightNo: product.detail.services[0].flightNo,
            productCode: product.detail.services[0].productCode
          }
        })

        allSegProductsParams = allSegProductsParams.concat(params)
      })

      let params = {
        'airlineCode': '8L',
        'products': allSegProductsParams
      }

      request({
        method: 'POST',
        url: '/api/flight/queryBenefit',
        data: params
      }).then((res) => {
        this.updateBenefit(res.benefits)
      }).catch((error) => {
        this.$message.error(error.message || '权益查询失败。')
      })
    },
    updateBenefit () {
      let beneMap = {
        'FREE_LUGGUE': {
          icon: 'icon-gongjuxiang',
          _text: '免费托运行李'
        },
        'UPMARKET_CHECK_IN_DESK': {
          icon: 'icon-jiedai',
          _text: '专属值机柜台'
        },
        'JP_REWARD_POINTS': {
          icon: 'icon-jifen2',
          _text: '累积积分'
        },
        'FOOD_IN_THE_AIR': {
          icon: 'icon-can',
          _text: '免费餐食'
        },
        'JJC_SEAT': {
          icon: 'icon-smile',
          _text: '经济舱座位'
        },
        'VIP_ROOM': {
          icon: 'icon-shafa',
          _text: '机场贵宾厅'
        },
        'BUSSINES_CHECK_IN_DESK': {
          icon: 'icon-jiedai',
          _text: '专属值机柜台'
        },
        'PRIORITY_SECURITY_CHECK_CHANNEL': {
          icon: 'icon-anjianchu1',
          _text: '优先安检通道'
        },
        'HIGHT_PIORITY_CHECK_IN': {
          icon: 'icon-feiji1',
          _text: '登机口优先登机'
        },
        'PERSONAL_CAR_TRAN': {
          icon: 'icon-qiche',
          _text: '远机位专车接驳'
        },
        'CABIN_SERVICE': {
          icon: 'icon-smile',
          _text: '品质客舱服务'
        },
        'EXTRA_REWARD_POINTS': {
          icon: 'icon-jifen2',
          _text: '额外积分'
        },
        'CHEAP_REFUND_CHANGE_SIGEN': {
          icon: 'icon-xunhuan',
          _text: '优惠退改签'
        },
        'ADVANCE_FREE_CHANGE': {
          icon: 'icon-xunhuan',
          _text: '免费改期'
        },
        'CARRY_LUGGUE': {
          icon: 'icon-gongjuxiang',
          _text: '手提行李'
        },
        'HIGH_JP_REWARD_POINTS': {
          icon: 'icon-jifen2',
          _text: '高额金鹏积分'
        },
        'DISCOUNT_ONBOARD_UP_CABIN': {
          icon: 'icon-xunhuan',
          _text: '优惠机上升舱'
        },
        'HOUR72_FREE_CHANGE': {
          icon: 'icon-xunhuan',
          _text: '72H外免费改期一次'
        }
      }
      _.each(this.innerItineraries, (iti) => {
        _.each(iti.productPrices, (product) => {
          let benefit = _.map(product.detail.services[0].benefit.benefits[0].benefitDetails, (benefit) => {
            return _.assign(benefit, beneMap[benefit.code])
          })
          this.$set(product, 'benefits', benefit)
        })
      })
    }
  }
}
</script>

<style lang="less">
  .popover-benefit-table {
    padding: 20px;
    tr {
      td {
        &:first-child {
          padding: 0 10px;
        }
      }
    }
  }
  .order-default-table {
    .benefit-table {
      tbody {
        tr {
          + tr {
            border-top: 0;
          }

          td {
            padding: 2px;
          }
        }
      }
    }
  }

  .benefit-icon {
    color: #9c8c6c;

    &.l8-icon {
      font-size: 14px;
    }
  }

  .cell-body {
    padding: 10px 18px;
    font-size: 12px;
    color: #808080;

    > div {
      margin: 10px 0;

      .anticon {
        font-size: 16px;
      }
    }

    th,
    td {
      padding: 8px;
      border: 1px solid #b7b7b7;
      text-align: center;

      &:first-child {
        background-color: #f5f5f5;
      }
    }

    .bussiness-tip {
      h6 {
        margin: 6px 0;
        color: @primary-color;
        font-size: 16px;
      }
    }
  }
</style>
